import StorageService from "./storageService";
import { useLocalStorage } from '@vueuse/core';

const hasUnseenMessages = useLocalStorage('hasUnseenMessages', StorageService.getItem('hasUnseenMessages'));

const setHasUnseenMessages = (hasUnread: boolean) => hasUnseenMessages.value = hasUnread;

export {setHasUnseenMessages, hasUnseenMessages}